import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import Calendars from '../../Components/calendar/Calendars'

import { Routes } from '../../routing/routes'

import './styles.scss'

const Login: FC = () => {
  const history = useHistory()
  const afterCalendarAdded = () => {
    history.push(Routes.PAGES_MANAGEMENT)
  }

  // TODO: replace calendars component with onboarding one?
  return (
    <div className="columns login">
      <div className="column is-4">
        <div className="box">
          <h2 className="title is-3">Login</h2>
          <Calendars
            nextThing={afterCalendarAdded}
            nextThingNewAccount={() => {
              history.push(Routes.ONBOARDING)
            }}
            oneIsEnough={true}
            nextThingText="Start scheduling meetings"
          />
        </div>
      </div>
    </div>
  )
}

export default Login
